interface IconProps {
  name: string;
  className?: string;
  fill?: boolean;
  size?: number;
}

/**
 * Material Symbols Outlined glyph (font loaded in index.html).
 *
 * The stroke weight comes from `--icon-wght` (default 300, the Ring Builder's
 * look); the studio sets 400 on `.editor-theme` so its icons match 13px text.
 */
export function Icon({ name, className = "", fill = false, size = 20 }: IconProps) {
  return (
    <span
      className={`material-symbols-outlined leading-none ${className}`}
      style={{
        fontSize: size,
        fontVariationSettings: `'FILL' ${fill ? 1 : 0}, 'wght' var(--icon-wght, 300), 'GRAD' 0, 'opsz' ${size}`,
      }}
    >
      {name}
    </span>
  );
}
